import { isProduction } from '../envUtils'

export const isActiveFlag = key => {
  if (isProduction) return false
  else {
    return localStorage.getItem(key)?.toLowerCase() === 'true'
  }
}
